<template>
  <table>
    <tbody>
      <tr>
        <td
          :colspan="
            datasource.children && datasource.children.length
              ? datasource.children.length * 2
              : null
          "
        >
          <div class="node" :id="datasource.id" @click.stop="handleClick(datasource)">
            <slot :node-data="datasource">
              <div class="title">
                <i class="fa fa-users symbol"></i>
                {{ datasource.name }}
              </div>
              <div class="progress-box" v-if="Array.isArray(datasource.content)">
                <div class="progress" :style="{width: `${getProgressAvg(datasource.content)}%`}"></div>
              </div>
              <div class="content" v-if="typeof datasource.content === 'string'">
                {{ datasource.content }}
              </div>
              <div class="content" v-if="Array.isArray(datasource.content)">
                <el-tooltip
                  placement="right"
                  v-for="(item, index) in datasource.content"
                  :key="index"
                 
                >
                  <div slot="content">
                    <!-- <div>{{item.kr}}</div> -->
                    <div v-html="item.kr" @click="tooltipClick(item)" class="content-tooltip"></div>
                    <!-- <div v-for="(data, i) in item.kr" :key="i">{{ data.text }}<br /></div> -->
                  </div>

                  <div class="content-detail">
                    {{ item.text }}
                  </div>
                </el-tooltip>
              </div>
            </slot>
          </div>
        </td>
      </tr>
      <template v-if="datasource.children && datasource.children.length">
        <tr class="lines">
          <td :colspan="datasource.children.length * 2">
            <div class="downLine"></div>
          </td>
        </tr>
        <tr class="lines">
          <td class="rightLine"></td>
          <template v-for="n in datasource.children.length - 1">
            <td class="leftLine topLine"></td>
            <td class="rightLine topLine"></td>
          </template>
          <td class="leftLine"></td>
        </tr>
        <tr class="nodes">
          <td colspan="2" v-for="child in datasource.children" :key="child.id">
            <node :datasource="child" :handle-click="handleClick" :tooltip-click="tooltipClick">
              <template
                v-for="slot in Object.keys($scopedSlots)"
                :slot="slot"
                slot-scope="scope"
              >
                <slot :name="slot" v-bind="scope" />
              </template>
            </node>
          </td>
        </tr>
      </template>
    </tbody>
  </table>
</template>

<script>
export default {
  name: "node",
  props: {
    datasource: Object,
    handleClick: Function,
    tooltipClick: Function
  },
  methods: {
    // 获取O的进度平均数
    getProgressAvg(oContent){
      const len = oContent.length;
      let avg = 0;
      if(len){
        let sum = 0;
        oContent.forEach(element => {
          if(element.progress){
            sum += element.progress;
          }
        });
        avg = Math.round(sum / len);
      }
      return avg;
    }
  },
};
</script>

<style></style>
